import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Plugins
import './plugins/fontawesome.js'
import FirstPlugin from "@/components/export/SplashMessage/SplashMessage";

// Styles and SCSS
import './assets/styles/app.scss'

// Custom Library
import cdnAsset from './lib/cdnAsset'

// Vendor Packages
import { BootstrapVue } from 'bootstrap-vue'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import { component as VueCodeHighlight } from 'vue-code-highlight'
import VueCompositionAPI from '@vue/composition-api'

// Vue Use
Vue.use(BootstrapVue)
Vue.use(VueCodeHighlight)
Vue.use(VueCompositionAPI)
Vue.use(FirstPlugin)
Vue.use(PerfectScrollbar)
Vue.config.productionTip = false

// Global Components
import CodePreviewViewer from '@/components/local/CodePreviewViewer'
import ButtonGroup from '@/components/export/ButtonGroup/ButtonGroup'

Vue.component('CodePreviewViewer', CodePreviewViewer)
Vue.component('ButtonGroup', ButtonGroup)

Vue.mixin({
  methods: {
    asset: (path) => cdnAsset(path)
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
